export default __webpack_public_path__ + "static/media/avatar-default.cf118178.svg";